
@if (!booking) {
  <div class="booking-list-item">
    <div class="booking-list-item__image skeleton-loading">
    </div>
    <div class="booking-list-item__content">
      <div class="booking-list-item__content-title skeleton-loading"></div>
    </div>
    <div class="booking-list-item__actions">
      <div class="booking-list-item__actions-button skeleton-loading"></div>
      <div class="booking-list-item__actions-button skeleton-loading"></div>
      <div class="booking-list-item__actions-button skeleton-loading"></div>
    </div>
  </div>
}

@if (booking) {
  <div class="booking-list-item">
    <div class="booking-list-item__image">
      @if (booking.service.image) {
        <app-image
          [src]="booking.service.image"
          [alt]="booking.service.name"
          preset="card"
          aspectRatio="1/1"
          [width]="156"
          [height]="156"
        ></app-image>
      }
      <img src="{{booking.service.image}}" alt="{{booking.service.name}}"/>
    </div>
    <div class="booking-list-item__content">
      <h3 class="booking-list-item__content-title">{{booking.service.name}}</h3>
      <div class="booking-list-item__content-photographer">
        <i class="fa-solid fa-camera-retro"></i>
        <p><a [routerLink]="['/', booking.service.photographerSlug]">{{booking.service.photographerName}}</a></p>
      </div>
      <div class="booking-list-item__content-infos">
        <div class="booking-list-item__content-info">
          <p class="booking-list-item__content-info-label">
            {{'marketplace.account.bookings.infos.price.label'|transloco}}
          </p>
          <p class="booking-list-item__content-info-value">
            {{booking.publicPrice|currency:'EUR'}}
          </p>
        </div>
        <div class="booking-list-item__content-info">
          <p class="booking-list-item__content-info-label">
            {{'marketplace.account.bookings.infos.date.label'|transloco}}
          </p>
          <p class="booking-list-item__content-info-value">
            {{ booking.datetime.toJSDate() | date: 'd MMMM y, HH:mm' }}
          </p>
        </div>
        <div class="booking-list-item__content-info">
          <p class="booking-list-item__content-info-label">
            {{'marketplace.account.bookings.infos.status.label'|transloco}}
          </p>
          <div class="booking-list-item__content-status booking-list-item__content-status--{{ booking.status }}">
            <p>{{ ('bookings.status.' + booking.status) | transloco }}</p>
          </div>
        </div>
      </div>

      @if (booking.status == 'pending') {
        <div class="booking-list-item__content-explanation">
          <app-helper-banner>
            <div helper-content>
              <p class="booking-list-item__content-explanation__text">
                {{'marketplace.account.bookings.pending.explanation'|transloco }}
              </p>
            </div>
          </app-helper-banner>
        </div>
      }

      @if (booking.status == 'shooting_done') {
        <div class="booking-list-item__content-explanation">
          <app-helper-banner>
            <div helper-content>
              <p class="booking-list-item__content-explanation__text">
                {{'marketplace.account.bookings.shooting-done.explanation'|transloco }}
              </p>
            </div>
          </app-helper-banner>
        </div>
      }
    </div>
    <div class="booking-list-item__actions">
      @if (shouldShowPayBalance()) {
        <button
          type="button"
          class="button button--full-width button--primary booking-list-item__actions-pay-balance"
          [disabled]="payingBalance"
          (click)="payRemainingBalance()"
        >
          <span>{{ 'marketplace.account.bookings.actions.pay-balance' | transloco }}</span>
          <span class="booking-list-item__actions-amount">
            {{ getBalanceAmount() | currency:'EUR' }}
          </span>
        </button>
      }
      <button
        class="button button--full-width"
        [disabled]="booking.status !== 'done'"
        [routerLink]="getPhotosUrl()"
        >
        {{'marketplace.account.bookings.actions.see-photos'|transloco}}
      </button>
      @if (booking.invoiceUrl !== null) {
        <a
          class="button button--full-width"
          [href]="booking.invoiceUrl"
          target="_blank"
          >
          {{'marketplace.account.bookings.actions.get-receipt'|transloco}}
        </a>
      }
    </div>
  </div>
}
